import { useState, useEffect, useCallback, useRef } from 'react';
import { apiClient } from '../api/client';

export function useProviders() {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);

  const fetchProviders = useCallback(async () => {
    try {
      // Only show full loading state on initial fetch
      if (!hasFetched.current) setLoading(true);
      setError(null);
      const data = await apiClient.getProviders();
      setProviders(data.providers || []);
      hasFetched.current = true;
    } catch (err) {
      setError(err.message || 'Failed to fetch providers');
      setProviders([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProviders();
  }, [fetchProviders]);

  // Get a specific provider by ID
  const getProvider = useCallback((providerId) => {
    return providers.find(p => p.id === providerId);
  }, [providers]);

  // Check if a provider is configured
  const isConfigured = useCallback((providerId) => {
    const provider = providers.find(p => p.id === providerId);
    return provider?.configured ?? false;
  }, [providers]);

  // Get list of configured providers
  const configuredProviders = providers.filter(p => p.configured);

  return {
    providers,
    configuredProviders,
    loading,
    error,
    refresh: fetchProviders,
    getProvider,
    isConfigured
  };
}
